import { ElementController, TOGGLE_EVENT } from 'js-common';

import { MENU_CONTROLLER_ID } from './constants';

const SEARCH_ITEM_SELECTOR = 'header-search';

/**
 * Controller for menu area.
 */
export default class Menu extends ElementController {
  static id = MENU_CONTROLLER_ID;

  /**
   * DOM loaded, initialize elements and bind events.
   */
  init() {
    // Search form toggle.
    const searchItem = this.selectSingle(SEARCH_ITEM_SELECTOR);
    if (searchItem) {
      this.searchInput = this.selectSingle(searchItem, 'input[type="search"]');
      this.searchToggle = this.selectSingle(
        searchItem,
        '[data-controller="Toggle"]',
      );
      this.on(this.searchToggle, TOGGLE_EVENT.toggle, this.handleSearchToggle);
      this.on(this.searchInput, 'keydown', this.handleSearchInputKeydown);
    }
  }

  /**
   * Focus the search input when opening its dialog.
   *
   * @param {object} e - Toggle event.
   * @param {boolean} isOpen - If the toggle is open.
   */
  handleSearchToggle = (e, isOpen) => {
    if (isOpen) {
      this.searchInput.focus();
    }
  };

  /**
   * Close dialog on escape click and focus the toggle button again.
   *
   * @param {object} e - Keydown event.
   */
  handleSearchInputKeydown = (e) => {
    if (e.key === 'Escape') {
      this.searchToggle.click();
      // Try to let the button go back to its collapsed state before setting
      // focus back on it.
      setTimeout(() => {
        this.searchToggle.focus();
      });
    }
  };
}
